module.exports = __webpack_public_path__ + "img/3451a95.svg";